module.exports = __webpack_public_path__ + "img/bg01_zhTc.5499f8f2.png";